/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Continue_WithoutInputs */

const en_directory_submit_badge_continue_without = /** @type {(inputs: Directory_Submit_Badge_Continue_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue without badge (nofollow)`)
};

const zh_directory_submit_badge_continue_without = /** @type {(inputs: Directory_Submit_Badge_Continue_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过徽章继续（nofollow）`)
};

/**
* | output |
* | --- |
* | "Continue without badge (nofollow)" |
*
* @param {Directory_Submit_Badge_Continue_WithoutInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_continue_without = /** @type {((inputs?: Directory_Submit_Badge_Continue_WithoutInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Continue_WithoutInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_continue_without(inputs)
	return zh_directory_submit_badge_continue_without(inputs)
});
export { directory_submit_badge_continue_without as "directory.submit.badge.continue_without" }